module.exports = __webpack_public_path__ + "world_map_naturalearth_ashkyd_clean_geo.e3eaa4ab94a580040f2fe1b71a5dd8c9.json";